import FeaturePage from "../../components/FeaturePage";
import { Users, MapPin, Receipt, ShieldCheck, Activity, Calendar } from "lucide-react";

export default function ManageOperations() {
  return (
    <FeaturePage
      badge="Manage Business Operations"
      title="Run the back office."
      highlight="Without burning out."
      subtitle="Manage staff, locations, expenses, and approvals from one calm dashboard. Don't do business blindly — see everything happening in real time."
      heroImage="https://images.unsplash.com/photo-1758887261865-a2b89c0f7ac5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="mint"
      features={[
        { icon: <Users size={22} />, title: "Staff & roles", desc: "Granular permissions, time tracking, performance reports per staff." },
        { icon: <MapPin size={22} />, title: "Multi-location", desc: "Run unlimited stores, branches, or pop-ups from one Brivo account." },
        { icon: <Receipt size={22} />, title: "Expense tracking", desc: "Log expenses, attach receipts, categorize, and tax-prep cleanly." },
        { icon: <ShieldCheck size={22} />, title: "Audit logs", desc: "Every action logged with user, time, location, and IP." },
        { icon: <Activity size={22} />, title: "Live activity feed", desc: "See what's happening across every location as it happens." },
        { icon: <Calendar size={22} />, title: "Shifts & schedules", desc: "Plan shifts, time off, and clock-ins with built-in scheduling." },
      ]}
      details={[
        {
          tag: "Staff",
          title: "Empower your team without giving away the keys.",
          desc: "Set granular roles — cashier, manager, accountant — and only show each person what they need to see. Track who did what, when.",
          bullets: ["Custom roles & permissions", "Per-staff sales reports", "Clock-in / clock-out tracking"],
        },
        {
          tag: "Locations",
          title: "One business. Many places. Zero confusion.",
          desc: "Whether you have two branches or two hundred, Brivo gives every location its own dashboard while rolling up to one company-wide view.",
          bullets: ["Per-location P&L", "Cross-location stock transfer", "Location-specific pricing"],
        },
        {
          tag: "Expenses",
          title: "Never lose a receipt again.",
          desc: "Log every expense, attach a photo of the receipt, categorize it, and have it ready for your accountant — automatically.",
        },
      ]}
      useCases={[
        { title: "Multi-store retail", desc: "Centralized control across all your branches." },
        { title: "Franchises", desc: "Roll-ups for HQ with autonomy at the unit level." },
        { title: "Distributed teams", desc: "Remote managers, on-the-floor staff, all in sync." },
        { title: "Small chains", desc: "From 2 to 200 locations, Brivo scales with you." },
      ]}
      ctaTitle="See everything. Control everything."
      ctaSubtitle="One dashboard for every staff, every location, every expense. Sleep better at night."
      ctaAccent="cream"
    />
  );
}
